import React from "react";
import { MediaContentContainer } from "../styled/common";

const MediaContent = ({ item, index, openComment, getFileCategory }) => {
  return (
    <MediaContentContainer isComment={openComment}>
      <div className="media">{getFileCategory(item, index)}</div>
    </MediaContentContainer>
  );
};

export default MediaContent;
